import React, { useState } from 'react';
import styled from 'styled-components';
import { Text } from '../index';
import { colors } from '../../../stylesheets';
import {
  getRadioButtonBorderColor,
  getRadioButtonBackgroundColor,
} from '../../../utils/getRadioButtonColor';

type Props = {
  title: string,
  disabled?: boolean,
  onChange: Function,
  className?: string,
  textSize?: 'xl' | 'lg' | 'mdb' | 'md' | 'sm' | 'xs',
  active?: boolean,
};

const StyledToggler = styled.div`
  width: 16px;
  height: 16px;
  border: ${(props) =>
      `${props.isActive ? '5px' : '1px'} ${
        colors[getRadioButtonBorderColor(props.isActive, props.isDisabled)]
      } `}
    solid;
  border-radius: 8px;
  background: ${(props) =>
    colors[getRadioButtonBackgroundColor(props.isActive, props.isDisabled)]};
`;

const RadioButton = ({
  title,
  disabled,
  onChange,
  textSize,
  active,
  className,
}: Props) => {
  const [isActiveRadio, setIsActiveRadio] = useState(active);

  const handleClick = () => {
    if (!disabled) {
      setIsActiveRadio(!isActiveRadio);
    }
    onChange(isActiveRadio);
  };

  return (
    <div
      onClick={handleClick}
      className={`flex-center-start w-100 px-2 py-1 ${className}`}
    >
      <StyledToggler
        className="ml-2"
        isActive={isActiveRadio}
        isDisabled={disabled}
      />
      <Text size={textSize}>{title}</Text>
    </div>
  );
};

RadioButton.defaultProps = {
  disabled: false,
  className: '',
  textSize: 'sm',
  active: false,
};

export default RadioButton;
